module.exports = __webpack_public_path__ + "img/intro.916639db.png";